import axios from "axios";


export class ControlsService{
    static serverURL = `${process.env.VUE_APP_HOST_API_BACKEND || "/api/dkbackend"}`;

    static getALLControls() {
        let dataURL = `${this.serverURL}/controls`;
        console.log('dataURL.usuario');
         console.log(dataURL);
            return axios.get(dataURL);
           
    }
    
    static getControl(controlId){
        let dataURL = `${this.serverURL}/control/${controlId}`;
        // console.log('dataURL');
        // console.log(dataURL);
            return axios.get(dataURL);
    }
    static getControlVSL_Id(vslId){
        let dataURL = `${this.serverURL}/controlvsl/${vslId}`;
        // console.log('dataURL');
        // console.log(dataURL);
            return axios.get(dataURL);
    }
    static createControl(control){
        let dataURL = `${this.serverURL}/control/`;
        console.log('dataURL.control');
        console.log(dataURL,control);
        return axios.post(dataURL,control);
    }
       

    static updateControl(control, vslId){
        let dataURL = `${this.serverURL}/control/${vslId}`;
        return axios.put(dataURL, control)
    }

    static deleteControl(controlId){
        let dataURL = `${this.serverURL}/control/${controlId}`;
        return axios.delete(dataURL);
    }

    
       


}